(function () {
  'use strict';
  if (window.__stMobileHeadingLoaded) return;
  window.__stMobileHeadingLoaded = true;

  function MobileHeading(section) {
    this.section = section;
    this.records = [];
    this.media = window.matchMedia('(max-width: 749px)');
    this.update = this.sync.bind(this);
    if (this.media.addEventListener) this.media.addEventListener('change', this.update);
    else this.media.addListener(this.update);
    this.sync();
  }

  MobileHeading.prototype.move = function (node, parent) {
    var focused = document.activeElement;
    var anchor = document.createComment('mobile-product-heading');
    node.parentNode.insertBefore(anchor, node);
    this.records.push({ node: node, anchor: anchor });
    parent.appendChild(node);
    if (focused && node.contains(focused) && document.activeElement !== focused) focused.focus({ preventScroll: true });
  };

  MobileHeading.prototype.sync = function () {
    if (!this.media.matches) { this.restore(); return; }
    if (this.header) return;
    var page = this.section.querySelector('.product__page');
    var gallery = page && page.querySelector('product-images');
    var head = this.section.querySelector('.product__head');
    var price = this.section.querySelector('.product__price__wrap');
    if (!gallery || gallery.parentNode !== page || !head || !price) return;
    var rating = this.section.querySelector('.shopify-app-block[id*="loox_reviews_loox_rating_"]');
    var header = document.createElement('div');
    header.className = 'st-mobile-product-heading';
    var summary = document.createElement('div');
    summary.className = 'product__block st-mobile-product-heading__price';
    page.insertBefore(header, gallery);
    this.header = header;
    this.move(head, header);
    header.appendChild(summary);
    this.move(price, summary);
    if (rating) this.move(rating, summary);
    var installments = this.section.querySelector('[data-product-form-installment]');
    var terms = installments && installments.closest('.shop-pay-terms');
    if (terms) this.move(terms, header);
  };

  MobileHeading.prototype.restore = function () {
    var focused = document.activeElement;
    var restoreFocus = this.header && this.header.contains(focused);
    this.records.slice().reverse().forEach(function (record) {
      if (record.anchor.parentNode) record.anchor.parentNode.replaceChild(record.node, record.anchor);
    });
    this.records = [];
    if (this.header) this.header.remove();
    this.header = null;
    if (restoreFocus && focused && document.activeElement !== focused) focused.focus({ preventScroll: true });
  };

  MobileHeading.prototype.destroy = function () {
    if (this.media.removeEventListener) this.media.removeEventListener('change', this.update);
    else this.media.removeListener(this.update);
    this.restore();
  };

  function sections(scope) {
    var selector = '[data-section-type="product"][data-mobile-product-heading]';
    var list = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) list.unshift(scope);
    return list;
  }
  function boot(scope) {
    sections(scope || document).forEach(function (section) {
      if (!section.stMobileHeading) section.stMobileHeading = new MobileHeading(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    sections(event.target).forEach(function (section) {
      if (section.stMobileHeading) section.stMobileHeading.destroy();
      delete section.stMobileHeading;
    });
  }, true);
})();
